import GenresMap from "./GenresMap";

function Genres() {
  return (
    <div className="h-screen text-center">
      <span className="uppercase descrip genreTitle font-bold text-[#f0ffff] hover:text-red-500 cursor-default text-2xl">
        genres
      </span>
      <GenresMap />
      <div className="py-36">{/*<Navigator />*/}</div>
    </div>
  );
}

export default Genres;
